import { useLocation, useNavigate } from 'react-router-dom';
import { DefaultButton } from '~/components/atomic';
import { FullScreenLoading, HelmetHead } from '~/components/common';
import { Header, SubCloseButton } from '~/components/common/Header';
import SetProfileView from '~/components/common/SetProfileView/SetProfileView';
import { useGetCharacterDetailsQuery } from '~/features/character';
import { useEditCharacter } from '~/hooks';
import { GetCharacterDetailsData } from '~/types';
import { PAGE_ROUTE } from '~/constants';

export default function EditCharacter() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const { data: characterDetails } = useGetCharacterDetailsQuery({
    character_id: state,
  });

  const {
    profileImage,
    commonInput,
    setCommonInput,
    showPersona,
    setShowPersona,
    textRef,
    handleUserNameClick,
    handleDirectionClick,
    isPending,
    GenerateButtonDisabled,
    handleEditClick,
    handleDeleteModalClick,
    handleImageChange,
    handleDeleteImageClick,
  } = useEditCharacter({
    characterId: state,
    data: characterDetails as GetCharacterDetailsData,
  });

  if (!state) {
    navigate(-1);
    return null;
  }

  return (
    <>
      <HelmetHead title='Edit Character' />

      {isPending && <FullScreenLoading />}

      <Header.Root>
        <Header.Section>
          <Header.PrevButton />
          <Header.Title>Set Profile</Header.Title>
        </Header.Section>
        <Header.Section>
          <SubCloseButton onCloseClick={() => navigate(PAGE_ROUTE.MYPAGE)} />
        </Header.Section>
      </Header.Root>

      <SetProfileView
        handleImageChange={handleImageChange}
        profileImage={profileImage}
        commonInput={commonInput}
        showPersona={showPersona}
        setShowPersona={setShowPersona}
        handleDeleteImageClick={handleDeleteImageClick}
        setCommonInput={setCommonInput}
        handleUserNameClick={handleUserNameClick}
        handleDirectionClick={handleDirectionClick}
        textRef={textRef}
        handleApplyClick={handleEditClick}
        isPending={isPending}
        GenerateButtonDisabled={GenerateButtonDisabled}
      >
        <DefaultButton colorType='black' onClick={handleDeleteModalClick}>
          Delete Character
        </DefaultButton>
      </SetProfileView>
    </>
  );
}
